import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/account-setup/carrier-code'
import pathMap from 'src/paths/PathMap_AccountSetup'

class TcalPartyCarrierCodeRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.TCAL_PARTY_CARRIER_CODE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.TCAL_PARTY_CARRIER_CODE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.TCAL_PARTY_CARRIER_CODE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.TCAL_PARTY_CARRIER_CODE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default TcalPartyCarrierCodeRoute
